export default {
  HEADING: 'Customers',
};
